<template>
  <div class="project-list">
    <!-- 顶部区域：左 logo 80x80，右信息 -->
    <div class="top-info">
      <img :src="imageView(match.icon)" class="match-icon" @click="removePassport" alt="" />
      <div class="top-info-right">
        <div class="match-name">{{ match.chineseName || '-' }}</div>
        <div class="match-status-row">
          <span class="status-tag" :class="{ success: isInRegistrationPeriod }">
            {{ isInRegistrationPeriod ? '报名中' : '未开始' }}
          </span>
        </div>
        <div class="match-date-row">{{ matchDateLabel }}：{{ matchDateRangeText }}</div>
        <div class="reg-date-row">
          <div>报名时间：[开始] {{ getRegDateTime(match.regBeginDate) }}</div>
          <div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[结束] {{ getRegDateTime(match.regEndDate) }}</div>
        </div>
      </div>
    </div>
    <div class="title">请选择赛事组别</div>
    <!-- 列表区域：左组别名称，右报名按钮 -->
    <div class="project-group">
      <div class="project" v-for="(project, index) in list" :key="index" @click="goEntry(project)">
        <span class="group-name">{{ project.group }}</span>
        <span v-if="project.isSignup > 0" class="signup-count">已报名{{ project.isSignup }}{{ getTeamCount(project.unitType) }}</span>
        <van-button class="btn-register" plain type="info" size="small">报名</van-button>
      </div>
    </div>
    <div class="dialog">
      <van-dialog v-model="showInvite" :title="project.group" show-cancel-button confirm-button-text="提交验证"
        confirm-button-color="#1565FC" @cancel="showInvite = false" :before-close="checkVerifyCode">
        <div class="info" style="margin-top: 20px">本组别为邀请制报名</div>
        <div class="info">请输入邀请码</div>
        <div style="text-align: center; margin: 20px 0 16px 0;">
          <input v-model="verifyCode" class="input" type="text" placeholder="请输入邀请码">
          <div v-if="showTip" style="color: #ee0a24; font-size: 11px">邀请码不能为空</div>
        </div>
      </van-dialog>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Toast, Tag, Icon, Dialog, Image as VanImage } from 'vant'
Vue.use(Tag).use(Icon).use(Dialog).use(VanImage)
import { getBMMatchList, getBMUnionMatch } from '@/api/match';
import { DateUtil, QNImageUtil } from "@/utils";
import { getPassport } from "@/libs/passport";
import { removeToken } from '@/libs/cookie-storage';
export default {
  data() {
    return {
      list: [],
      match: {},
      showInvite: false,
      project: {},
      verifyCode: '',
      showTip: false,
      place: []
    }
  },
  computed: {
    // 判断是否在报名时间范围内
    isInRegistrationPeriod() {
      if (!this.match.regBeginDate || !this.match.regEndDate) {
        return false
      }
      const now = new Date()
      const beginDate = new Date(this.match.regBeginDate)
      const endDate = new Date(this.match.regEndDate)
      return now >= beginDate && now <= endDate
    },
    // 赛事项目为「综合 / 综合类」时，顶部日期标签使用「举办日」
    matchDateLabel() {
      const t = this.match.sportType
      return t === '综合' || t === '综合类' ? '举办日期' : '比赛日期'
    },
    // 起止为同一天时仅展示一个日期（与结束日一致，避免重复）
    matchDateRangeText() {
      const begin = this.getFormatDate(this.match.beginDate)
      const end = this.getFormatDate(this.match.endDate)
      if (begin && end && begin === end) {
        return end
      }
      if (begin && end) {
        return `${begin}～${end}`
      }
      return begin || end || ''
    }
  },
  mounted() {
    this.unionMatchId = this.$route.query.unionMatchId
    this.getBMMatchList()
    this.getBMUnionMatch()
  },
  methods: {
    removePassport() {
      removeToken()
      Toast.success('退出登录成功')
    },
    imageView(img) {
      if (!img) return ''
      return QNImageUtil.imageView(img)
    },
    getBMUnionMatch() {
      const params = {
        unionMatchId: this.unionMatchId
      }
      getBMUnionMatch(params).then(res => {
        if (res) {
          const { data } = res
          this.match = data.match || {}
          if (this.match.province) {
            this.place.push(this.match.province)
          }
          if (this.match.city) {
            this.place.push(this.match.city)
          }
          if (this.match.location) {
            this.place.push(this.match.location)
          }
          const shareObj = {
            title: this.match.chineseName,
            abstract: '点我报名',
            image: QNImageUtil.imageView(this.match.icon)
          }
          this.wxShare(shareObj)
        }
      })
    },
    getTeamCount(unitType) {
      if (unitType === 0) {
        return '队'
      } else if (unitType === 1) {
        return '人'
      } else {
        return '组'
      }
    },
    getBMMatchList() {
      const params = {
        unionMatchId: this.unionMatchId
      }
      getBMMatchList(params).then(res => {
        if (res) {
          const data = res.data
          this.list = data.list.filter(item => item.allowTeamSignup !== 0 || item.publicSignUp !== 0)
          if (this.list.length === 1 && !(this.list[0].publicSignUp === 0 && this.list[0].allowTeamSignup === 1) && (this.list[0].teamLimitCount - this.list[0].teamCount > 0)) {
            // this.goPages(this.list[0])
            const project = this.list[0]
            if (project.unitType === 0) {
              this.$router.replace('/entry-page/entry-info-team?unionMatchId=' + this.unionMatchId + '&matchId=' + project.id)
            } else if (project.unitType === 1) {
              this.$router.replace('/entry-page/entry-info-person?unionMatchId=' + this.unionMatchId + '&matchId=' + project.id)
            } else {
              this.$router.replace('/entry-page/entry-info-more?unionMatchId=' + this.unionMatchId + '&matchId=' + project.id)
            }
          }
        }
      })
    },
    goEntry(project) {
      getPassport().then(res => {
        if (res) {
          // 判断是否在报名时间范围内
          if (!this.isInRegistrationPeriod) {
            Dialog.alert({ title: '提示', message: '当前不在报名时间内' })
            return
          }
          if (project.isOpenTeamLimit === 1 && project.teamLimitCount - project.teamCount <= 0) {
            Dialog.alert({ title: '提示', message: (project.group || '该组别') + '名额已满' })
            return
          }
          if (project.isSignup > 0) {
            // 已有报名：直接进入该组别的报名列表页（列表 + 底部新增球队）
            this.$router.push({
              path: '/entry-page/entry-list-by-group',
              query: {
                unionMatchId: this.unionMatchId,
                matchId: project.id,
                unitType: project.unitType,
                groupName: project.group
              }
            })
          } else {
            this.goPages(project)
          }
        }
      })
    },
    goPages(project) {
      if (project.publicSignUp === 0 && project.allowTeamSignup === 1) {
        this.project = project
        this.showInvite = true
      } else {
        if (project.unitType === 0) {
          this.$router.push('/entry-page/entry-info-team?unionMatchId=' + this.unionMatchId + '&matchId=' + project.id)
        } else if (project.unitType === 1) {
          this.$router.push('/entry-page/entry-info-person?unionMatchId=' + this.unionMatchId + '&matchId=' + project.id)
        } else {
          this.$router.push('/entry-page/entry-info-more?unionMatchId=' + this.unionMatchId + '&matchId=' + project.id)
        }
      }
    },
    getFormatDate(date) {
      if (!date) return ''
      return DateUtil.parseDateTime(date, '{y}-{m}-{d}')
    },
    getRegDateTime(date) {
      if (!date) return '-'
      return DateUtil.parseDateTime(date, '{y}-{m}-{d} {h}:{i}')
    },
    checkVerifyCode(action, done) {
      if (action === 'cancel') {
        this.verifyCode = ''
        this.showTip = false
        done()
      } else {
        if (!this.verifyCode) {
          this.showTip = true
          done(false)
        } else if (this.verifyCode === this.project.verifyCode) {
          this.verifyCode = ''
          this.showTip = false
          done()
          if (this.project.teamLimitCount - this.project.teamCount > 0) {
            if (this.project.unitType === 0) {
              this.$router.push('/entry-page/entry-info-team?unionMatchId=' + this.unionMatchId + '&matchId=' + this.project.id)
            } else if (this.project.unitType === 1) {
              this.$router.push('/entry-page/entry-info-person?unionMatchId=' + this.unionMatchId + '&matchId=' + this.project.id)
            } else {
              this.$router.push('/entry-page/entry-info-more?unionMatchId=' + this.unionMatchId + '&matchId=' + this.project.id)
            }
          } else {
            Dialog.alert({ title: '提示', message: (this.project.group || '该组别') + '名额已满' })
          }
        } else {
          Dialog.alert({ title: '提示', message: '邀请码填写错误，请重新输入' }).finally(() => {
            done(false)
          })
        }
      }
    }
  }
}
</script>

<style lang="scss">
.project-list {
  background-color: #F6F6F8;
  min-height: 100vh;
  .top-info {
    display: flex;
    align-items: flex-start;
    padding: 16px;
    background: #fff;
    .match-icon {
      width: 80px;
      height: 80px;
      border-radius: 8px;
      flex-shrink: 0;
      object-fit: cover;
      background: #e8e8e8;
    }
    .top-info-right {
      flex: 1;
      min-width: 0;
      margin-left: 12px;
    }
    .match-name {
      font-size: 15px;
      font-weight: 600;
      color: #1d2129;
      line-height: 22px;
      margin-bottom: 8px;
    }
    .match-status-row {
      margin-bottom: 6px;
      .status-tag {
        display: inline-block;
        font-size: 12px;
        padding: 2px 8px;
        border-radius: 4px;
        background: #e8e8e8;
        color: #86909c;
        &.success {
          background: #0fac7f;
          color: #fff;
        }
      }
    }
    .match-date-row {
      font-size: 12px;
      color: #999999;
      line-height: 18px;
      margin-bottom: 4px;
    }
    .reg-date-row {
      font-size: 12px;
      color: #434343;
      line-height: 18px;
      div {
        margin-bottom: 2px;
      }
    }
  }
  .title {
    font-size: 15px;
    color: #909399;
    height: 40px;
    line-height: 40px;
    padding: 0 16px;
  }
  .project-group {
    background: #fff;
    padding: 0 16px;
    .project {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 14px 0;
      border-bottom: 1px solid #f1f1f1;
      &:last-child {
        border-bottom: none;
      }
      .group-name {
        font-size: 15px;
        color: #1d2129;
        flex: 1;
        min-width: 0;
        padding-right: 12px;
      }
      .signup-count {
        color: #797979;
        font-size: 14px;
        margin-right: 14px;
      }
      .btn-register {
        flex-shrink: 0;
        min-width: 72px;
        height: 32px;
        border-radius: 4px;
        border-color: var(--bg3);
        color: var(--bg3);
        font-size: 14px;
      }
    }
  }
  
  .projects {
    background-color: #FFFFFF;
    padding: 0 12px 12px;

    .title {
      background-color: #FFFFFF;
      display: flex;
      align-items: center;
      font-weight: 500;
      font-size: 15px;
      color: #333333;
      padding: 18px 0 13px 0;
      border-bottom: 0.5px #EEEEEE solid;

      .icon {
        width: 2px;
        height: 12px;
        background-color: #2D60DF;
        margin-right: 6px;
      }
    }

    .project {
      height: 66px;
      padding: 16px 12px 12px 12px;
      box-sizing: border-box;
      margin-top: 12px;
      background-size: 100% 100%;
      background-repeat: no-repeat;
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .logo {
        width: 24px;
        height: 24px;
      }

      .icon {
        width: 20px;
        height: 20px;
      }
    }
  }

  .p-n {
    font-size: 14px;
    color: #36b02f;
  }

  .m-n {
    font-size: 14px;
    color: #7661f8;
  }

  .t-n {
    font-size: 14px;
    color: #fe7d1c;
  }

  .d-n {
    font-size: 14px;
    color: #333333;
  }

  .p {
    background-image: url('../../../assets/project-list/person_bgi.png');
  }

  .m {
    background-image: url('../../../assets/project-list/more_bgi.png');
  }

  .t {
    background-image: url('../../../assets/project-list/team_bgi.png');
  }

  .d {
    background-image: url('../../../assets/project-list/disable_bgi.png');
  }

  .dialog {
    .info {
      font-size: 14px;
      color: #8C8C8C;
      text-align: center;
      line-height: 18px;
    }

    .input {
      width: calc(100% - 30px);
      background-color: #F4F4FB;
      height: 46px;
      border: none;
      border-radius: 23px;
      font-size: 16px;
      color: #333333;
      text-align: center;
    }

    .input::placeholder {
      text-align: center;
    }
  }
}
</style>
